import React, { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { I18nProvider } from "../i18n/I18nContext";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Toaster } from "sonner";

const VALID_LANGS = ["en", "ro"];

export default function LangLayout() {
  const { lang } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!VALID_LANGS.includes(lang)) {
      const stored = localStorage.getItem("lp_lang");
      const browser =
        typeof navigator !== "undefined" && (navigator.language || "").toLowerCase().startsWith("ro")
          ? "ro"
          : "en";
      navigate(`/${stored && VALID_LANGS.includes(stored) ? stored : browser}`, { replace: true });
    }
  }, [lang, navigate]);

  if (!VALID_LANGS.includes(lang)) return null;

  return (
    <I18nProvider>
      <div className="relative min-h-screen grain">
        <Navbar />
        <main className="pt-24 md:pt-28 relative z-10">
          <Outlet />
        </main>
        <Footer />
        <Toaster theme="dark" position="top-center" richColors />
      </div>
    </I18nProvider>
  );
}
